<template>
    <div>

        <div class="title"><span></span><h1>添加SIM卡设备号</h1></div>
        <el-form>
        	<el-form-item class="btnArea">
                <el-upload ref="upload"  style="display: inline-block; margin-left: 10px;" :show-file-list="false" 
                :action="uploadUrl('sim/import/excel/update/sn')" :headers="setHeader()" 
                :limit="1" :data="importFields" :on-success = "handleSuccess">
                    <el-button slot="trigger" plain>导入Excel</el-button>
                </el-upload> 
                <span>
                    <a class="export-tamplate" href="../../../doc/importTamplate.xls" download="卡片导入模板.xls">下载模板</a>
                </span> 
                 <span>
                   <el-button slot="trigger" plain @click="getLimitDataList()">刷新</el-button>
                </span>
            </el-form-item>
        </el-form>

        <el-table :data="tbpg.tableData" border >
            <el-table-column type="index" label="序号" ></el-table-column>
            <el-table-column prop="iccid" label="ICCID" ></el-table-column>
            <el-table-column prop="agent_name" label="处理人" ></el-table-column>
            <el-table-column label="修改时间" >
                <template v-slot="scope">
                    {{dateFormat('yyyy-MM-dd hh:mm:ss', new Date(scope.row.create_time))}}
                </template> 
            </el-table-column>
            <el-table-column prop="remark" label="设备号" ></el-table-column>
            
        </el-table>
        <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="tbpg.currentPage"
            :page-sizes="[15, 50, 100, 500]"
            :page-size="tbpg.pageSize"
            layout="total, sizes, prev, pager, next, jumper"
            :total="tbpg.total">
        </el-pagination>  

    </div>
</template>
<script>
import common from '@/utils/common.js'
export default {
    data(){         
        return {
            importFields:{},
            updateFlowdataFields:{},

            tbpg: {
                tableData: [],
                currentPage: 1,
                pageSize: 15,
                total: 0                
            },
        }
    },
    methods: {
        
        handleSuccess(res){
            if(res.code == 200){
                this.$refs.upload.clearFiles();
                this.$message.success(res.message);
                this.getLimitDataList();
            }else{
                this.$message.error(res.message);
            }
        },

        exportSimData(){//导出excel文件
            this.exportExcel('/excel/update/sim/data', {});

            this.$message.success('下载中……');
        },

        getLimitDataList(){
            common.sysRequest('sim/select/update/sn/list', {}, 'post').then(res => {
                if(res.data.code == 200){
                    common.listCallback(this, res, 'tbpg');
                }
            })
        },

        handleSizeChange(val){
            this.tbpg.pageSize = val;
            this.getLimitDataList();
            
        },
        handleCurrentChange(val){
            this.tbpg.currentPage = val;
            this.getLimitDataList();
            
        }
    },
    created () {
        this.getLimitDataList();
    },

    computed: {
        
    },

    watch:{

    }
}
</script>


<style lang="scss" scoped>

    .title{
        height: 32px;
        line-height: 32px;
        margin-bottom: 10px;

        span{
            display: inline-block;
            height: 22px;
            width: 5px;
            margin-right: 5px;
            background: #2196f3;
            vertical-align: bottom;
        }
        h1{
            display: inline-block;
            height: 18px;
            line-height: 16px;
            font-size: 14px;
            font-weight: bold;
            width: 300px;
            vertical-align: bottom;
        }
    }
    .export-tamplate{
        box-sizing: border-box;
        border: 1px solid #dcdfe6;
        border-radius: 3px;
        width: 85px;
        height: 32px;
        display: inline-block;
        text-align: center;
        vertical-align: bottom;
        margin-left: 10px;
        font-size: 13px;
        color: #606266;
    }

    .export-tamplate:hover{
        color: #409EFF;
        border-color: #409EFF;
        transition: .3s;
    }
</style>